import { getAuthState } from '../../../hooks/useAuth';

let auth = getAuthState()

export const aivUploadListFunilize = async (path:string, id_lista:string, cnpj?:string): Promise<any> => {
    try {
        if (!path || !id_lista) return false;
        auth = getAuthState()
        const response = await fetch(`https://f5gkmqm2yh.execute-api.us-east-1.amazonaws.com/prod/aiv/list/funilize`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.idToken
            },
            body: JSON.stringify({
                path:path,
                id_lista:id_lista,
                cnpj:cnpj ?? null
            }),
        });

        const data = await response.json()

        return data;

    } catch (error) {
        console.error('Error importing list:', error);
        return false;
    }
};